<template>
    <b-modal v-model="ShowModal" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
        no-close-on-esc='true' centered hide-header hide-footer>
        <template v-slot:default="">
            <p><b>"Original Document Selection" is not available at the moment. Please download our eRemit app in Play store or App store and select "Online Submission" to complete your registration.
                Please use your registered phone number to log in and proceed with your registration.</b>
            </p>
            <br />
            <div class="modal-button-wrapper">
                <b-button  block variant="danger" @click="handleOk">OK</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
    import CommonService from "../services/common";
    export default {
        name: "DisableButtonDialog",
        props: ["ShowModal"],
        methods: {
            handleOk: function (evt) {                              
                this.ShowModal = false;
                this.$emit('okclicked', this.ShowModal);
                evt.preventDefault();
            }
        }
    };
</script>
